import { Plus } from 'lucide-react'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '@/components/ui/button'
import { useAuth } from '@/lib/auth/AuthProvider'
import { ExpenseTable } from '../../CustomerExpensesPage'
import { EXPENSE_PERMS as P, useCustomerExpenses } from '../../expenses'
import type { Meeting } from '../../types'
import { ExpenseDetailModal } from './ExpenseDetailModal'
import { ExpenseFormModal } from './ExpenseFormModal'

/** Toplantıya bağlı müşteri giderleri (onay akışıyla). */
export function MeetingExpenses({ meeting: m }: { meeting: Meeting }) {
  const { t } = useTranslation()
  const { can } = useAuth()
  const canSee = can(P.create) || can(P.readAll) || can(P.approve)
  const q = useCustomerExpenses({ accountId: m.customerId, meetingId: m.id }, canSee)
  const [adding, setAdding] = useState(false)
  const [open, setOpen] = useState<string | null>(null)
  if (!canSee) return null
  const rows = q.data ?? []
  return (
    <section className="space-y-2">
      <div className="flex items-center justify-between gap-2">
        <h3 className="text-sm font-semibold">{t('crm.meeting.expenses')}</h3>
        {can(P.create) ? (
          <Button size="sm" variant="outline" onClick={() => setAdding(true)}>
            <Plus />
            {t('common.add')}
          </Button>
        ) : null}
      </div>
      {rows.length ? (
        <div className="rounded-lg border">
          <ExpenseTable rows={rows} hideCustomer onOpen={setOpen} />
        </div>
      ) : (
        <p className="text-xs text-muted-foreground">{t('crm.meeting.noExpenses')}</p>
      )}
      {adding ? <ExpenseFormModal accountId={m.customerId} meetingId={m.id} onClose={() => setAdding(false)} /> : null}
      {open ? <ExpenseDetailModal id={open} onClose={() => setOpen(null)} /> : null}
    </section>
  )
}
